// extracted by mini-css-extract-plugin
module.exports = {"noMargin":"styles_noMargin__3CIzw","iconContainer":"styles_iconContainer__3CcgD","small":"styles_small__vnASP","large":"styles_large__3HCGD"};